import Button from "./Button";
import { useCallback } from "react";
import useAppState from "../lib/hooks/useAppState";
import { Mainnet, useEthers } from "@usedapp/core";
import useWalletConnect from "../lib/hooks/useWalletConnect";
import { Wallet } from "lucide-react";

export default function AccountInfo() {
  const { isConnected } = useAppState();
  const { chainId, switchNetwork } = useEthers();
  const { openWalletConnect } = useWalletConnect();

  const handleChangeNetwork = useCallback(() => {
    switchNetwork(Mainnet.chainId);
  }, [switchNetwork]);

  const renderButton = useCallback(() => {
    if (!isConnected) {
      return (
        <div className="relative group w-full max-w-xs">
          <button
            className="bg-primary text-background w-full px-4 py-4 rounded-md flex items-center justify-center gap-4"
            onClick={openWalletConnect}
          >
            <Wallet className="w-4 h-4" />
            Connect Wallet
          </button>
        </div>
      );
    }
    if (chainId !== Mainnet.chainId) {
      return (
        <div className="space-y-2 w-full flex flex-col items-center">
          <Button disableElevation onClick={handleChangeNetwork}>
            Switch to Mainnet
          </Button>
          <div className="text-red-300">You are not connected to Mainnet.</div>
        </div>
      );
    }
    return null;
  }, [handleChangeNetwork, isConnected, openWalletConnect, chainId]);

  return (
    <div className="flex flex-col items-center space-y-4 w-full">
      {renderButton()}
    </div>
  );
}
